module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5znd4"))).then(() => parcelRequire('iDpjN'));